import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { HeaderReviewWidget, IHeaderReviewWidget } from "./headerReviewWidget";
import { IProductReviewsAggregate, IReviewsAggregate } from "./reviewsAggregate";
import { IReviewWidgetAggregatePanel, ReviewWidgetAggregatePanel } from "./reviewWidgetAggregatePanel";
import { IReviewWidgetAggregatePanelProduct, ReviewWidgetAggregatePanelProduct } from "./reviewWidgetAggregatePanelProduct";
import { IReviewWidgetBase, ReviewWidgetBase } from "./reviewWidgetBase";
import { IReviewWidgetPager, ReviewWidgetPager } from "./reviewWidgetPager";

export interface IProductReviewWidget extends IReviewWidgetBase {
    reviewsAggregate: IProductReviewsAggregate;
}

export class ProductReviewWidget extends ReviewWidgetBase implements IProductReviewWidget {
    public reviewsAggregate: IProductReviewsAggregate;
    public reviewWidgetAggregatePanel: IReviewWidgetAggregatePanelProduct;
    public headerReviewWidget: IHeaderReviewWidget;
    
    constructor(public htmlElement: Element) {
        super(htmlElement);

        this.setReviewsAggregateFactory();
        this.createHeaderReviewWidget();
    }

    createHeaderReviewWidget():void{
        let headerReviewWidgetElement: HTMLElement | null = this.getHtmlElementForHeaderReviewWidget();
        if (headerReviewWidgetElement) {
            this.headerReviewWidget = new HeaderReviewWidget(headerReviewWidgetElement);
        }
    }

    getHtmlElementForHeaderReviewWidget():HTMLElement{
        let headerReviewWidgetlElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.headerReviewWidget))
        return headerReviewWidgetlElement;
    }

    setReviewsAggregateFactory(): void{
        let reviewsAggregateElement: HTMLElement | null = this.getHtmlElementForReviewWidgetAggregatePanel();
        if (reviewsAggregateElement) {
            this.reviewWidgetAggregatePanel = new ReviewWidgetAggregatePanelProduct(reviewsAggregateElement);
        }
    }

    getHtmlElementForReviewWidgetAggregatePanel():HTMLElement{
        let reviewWidgetAggregatePanelElement: HTMLElement = this.htmlElement.querySelector(HelperUtils.addDataAttributeTags(AttributeEnums.ReviewComponents.reviewWidgetAggregatePanel))
        return reviewWidgetAggregatePanelElement;
    }

    update(productReviewsAggregate: IProductReviewsAggregate, newReviews: string, clearReviews: boolean){
        this.headerReviewWidget.update(productReviewsAggregate.reviewsAverage, productReviewsAggregate.totalReviews);
        this.reviewWidgetAggregatePanel.update(productReviewsAggregate.reviewsAverage, productReviewsAggregate.totalReviews, productReviewsAggregate.reviewsSummary, productReviewsAggregate.featureAggregates.qualityAverage, productReviewsAggregate.featureAggregates.valueForMoneyAverage );
        this.reviewWidgetPager.update(productReviewsAggregate.selectedRating, productReviewsAggregate.reviewsSummary, productReviewsAggregate.page, newReviews, clearReviews);
    }

    dispose() {
        try {
            console.log(`ProductReviewWidget: dispose`);
           
            if (this.headerReviewWidget) {
                this.headerReviewWidget.dispose();
            }
            if (this.reviewWidgetAggregatePanel) {
                this.reviewWidgetAggregatePanel.dispose();
            }
            if (this.reviewWidgetPager) {
                this.reviewWidgetPager.dispose();
            }
          
        } catch (error) {
            console.log('ProductReviewWidget: dispose ERROR', error);
        }
    }
}